import { render, staticRenderFns } from "./NavigationTab.vue?vue&type=template&id=6dc451f9"
import script from "./NavigationTab.ts?vue&type=script&lang=ts&external"
export * from "./NavigationTab.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports